import { type GridCellProps } from '@progress/kendo-react-grid'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router'

import { compile } from '~/apps/ninesegsAnalyzer/routes/paths'
import { HStack } from '~/components/elements/HStack'
import { Typography } from '~/components/elements/Typography'
import { type BrandGroup } from '~/hooks/useSurveyForSettingsQuery'

import { useSurveyId } from '../hooks/useSurveyId'

export type LinksCellProps = Omit<GridCellProps, 'dataItem'> & {
  dataItem: BrandGroup
}

export const LinksCell = ({ dataItem: brandGroup }: LinksCellProps) => {
  const { t } = useTranslation()
  const surveyId = useSurveyId()

  return (
    <td>
      <HStack align="center" backgroundColor="transparent" spacing={4}>
        <Link
          to={compile('brandList', {
            surveyId,
            brandGroupId: `${brandGroup.id}`,
          })}
        >
          <Typography variant="link3">{t('brand_list')}</Typography>
        </Link>

        <Link
          to={compile('segmentDefinitions', {
            surveyId,
            brandGroupId: `${brandGroup.id}`,
          })}
        >
          <Typography variant="link3">{t('9segs_definition')}</Typography>
        </Link>
      </HStack>
    </td>
  )
}
